import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";

import { Popper } from "../../../components/simple";
import { defaultOptions } from "../../../helpers/popoverOptions";
import SVG from "../../../components/SVG";

import "./styles.scss";

function VariableGroup(props) {
  const { variables, showAnd } = props;

  return (
    <Fragment>
      {showAnd && <span className="operand">AND</span>}
      <div className="group">
        {variables.map((variable, varIndex) => (
          <Fragment key={`preset-variable-list-render-${variable.id}`}>
            <span
              className={`variable-item ${!variable.active ? "inactive" : ""}`}
            >
              {variable.name}
            </span>
            {varIndex !== variables.length - 1 && (
              <span className="operand">OR</span>
            )}
          </Fragment>
        ))}
      </div>
    </Fragment>
  );
}

VariableGroup.propTypes = {
  variables: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  showAnd: PropTypes.bool.isRequired
};

export default function VariableList(props) {
  const { list } = props;

  return (
    <div className="preset-variable-list">
      {list.map((groups, index) => (
        <div className="group-container" key={groups.id}>
          <VariableGroup variables={groups.variables} showAnd={index !== 0} />
        </div>
      ))}
    </div>
  );
}

VariableList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

function VariableItem(props) {
  const [isVariablePopover, setVariablePopover] = useState(false);

  const { variable = {}, varId, notLastVariable } = props;

  return (
    <Fragment key={`list-item-${variable.id}`}>
      <span
        id={varId}
        className={`variable-item ${!variable.active ? "inactive" : ""}`}
        onMouseEnter={() => {
          if (!variable.active) setVariablePopover(true);
        }}
        onMouseLeave={() => setVariablePopover(false)}
      >
        {variable.name}
        {!variable.active ? (
          <div className="inactive-icon">
            <SVG.InfoCircle width={20} height={20} />
          </div>
        ) : null}
      </span>
      {notLastVariable && <span className="operand">OR</span>}
      <Popper
        popperOptions={{
          className: `${defaultOptions.className} alert-popper`,
          placement: "right",
          target: varId,
          isOpen: isVariablePopover,
          toggle: () => {
            setVariablePopover(false);
          }
        }}
      >
        <div className="help-container">
          <h4>Notification</h4>
          <p>
            Some of the selected variables were changed. Please make adjustment
          </p>
        </div>
      </Popper>
    </Fragment>
  );
}

VariableItem.propTypes = {
  variable: PropTypes.shape({}).isRequired,
  varId: PropTypes.string.isRequired,
  notLastVariable: PropTypes.bool.isRequired
};

function VariablesGroup(props) {
  const { group, showAnd, groupId } = props;

  return (
    <Fragment>
      {showAnd && <span className="operand">AND</span>}
      <div className="group">
        {group.map((variable, varIndex) => (
          <VariableItem
            variable={variable}
            // eslint-disable-next-line react/no-array-index-key
            key={groupId + varIndex}
            varId={groupId + varIndex}
            notLastVariable={varIndex !== group.length - 1}
          />
        ))}
      </div>
    </Fragment>
  );
}

VariablesGroup.propTypes = {
  group: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showAnd: PropTypes.bool.isRequired,
  groupId: PropTypes.string.isRequired
};

export function VariableListBuilder(props) {
  const { list } = props;
  return (
    <div className="preset-variable-list-height">
      {list.map((groups, index) => (
        <div
          className="group-container"
          // eslint-disable-next-line react/no-array-index-key
          key={`group-${groups.length}-${groups?.[0]?.name}`}
        >
          <VariablesGroup
            groupId={`preset-variable-list-item-${index}`}
            group={groups}
            showAnd={index !== 0}
          />
        </div>
      ))}
    </div>
  );
}

VariableListBuilder.propTypes = {
  list: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired
};
